import {useTranslation} from "react-i18next";
import {Aufgabe} from "../../api";
import {usePromptsByAufgabeInbound} from "../../client/queries";
import {useAufgabenInboundPromptHandling} from "../../hooks/aufgaben/useAufgabenInboundPromptHandling";
import {PromptVersionEditorBase} from "./AufgabePromptVersionEditor";

interface Props {
    aufgabe: Aufgabe;
    canEdit: boolean;
    selectedPromptId?: string;
    onSelectPrompt?: (promptId: string) => void;
}

export default function AufgabeInboundPromptVersionEditor({aufgabe, canEdit, selectedPromptId, onSelectPrompt}: Props) {
    const {t: translation} = useTranslation('aufgaben');
    const versions = usePromptsByAufgabeInbound(aufgabe.id);
    const {createPromptMutation, updatePromptMutation, setActivePromptMutation, deletePromptMutation} = useAufgabenInboundPromptHandling(aufgabe.id);

    return (
        <PromptVersionEditorBase
            entityId={aufgabe.id}
            versions={versions}
            activePromptId={aufgabe.active_inbound_prompt_id}
            canEdit={canEdit}
            sprache={aufgabe.sprache}
            title={translation('inbound-prompt-versions-title')}
            noneSelectedText={translation('inbound-prompt-version-none')}
            createPromptMutation={createPromptMutation}
            updatePromptMutation={updatePromptMutation}
            setActivePromptMutation={setActivePromptMutation}
            deletePromptMutation={deletePromptMutation}
            selectedPromptId={selectedPromptId}
            onSelectPrompt={onSelectPrompt}
        />
    );
}
